import request from '@/utils/request';
import baseUrl from '@/api/baseUrl';

export function loginByEmail(userEmail, password, loginAppType, safeLogin) {
  const data = {
    userEmail,
    password,
    loginAppType,
    safeLogin
  };
  return request({
    url: baseUrl.udcd + 'login/userPwdLogin',
    method: 'post',
    data
  });
}

export function logout(urlParams) {
  return request({
    url: baseUrl.udcd + 'logout/logout'+ urlParams,
    // url: 'logout/logout',
    method: 'post'
  });
}

export function getInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token }
  });
}




// WEBPACK FOOTER //
// ./src/api/login.js